<template>
  <zen-one title="">
    <z-page title="Dasar Privasi">
      <w-card class="premis-card modern-card">
      	<br>
      	<br>
      	<b style="font-size: 16px;">Privasi Anda</b>
      	<br>
      	<br>
      	Halaman ini menerangkan dasar privasi yang merangkumi penggunaan dan perlindungan maklumat yang dikemukakan oleh pengunjung. Sekiranya anda membuat transaksi atau menghantar e-mel yang mengandungi maklumat peribadi, maklumat ini mungkin akan dikongsi bersama dengan agensi awam lain untuk membantu penyediaan perkhidmatan yang lebih berkesan dan efektif. Contohnya seperti di dalam menyelesaikan aduan yang memerlukan maklum balas dari agensi-agensi lain.
      	<br>
      	<br>
      	<b style="font-size: 16px;">Maklumat Yang Dikumpul</b>
      	<br>
      	<br>
      	Tiada maklumat peribadi akan dikumpul semasa anda melayari laman web ini kecuali maklumat yang dikemukakan oleh anda melalui e-mel.
      	<br>
      	<br>
      	<b style="font-size: 16px;">Apa yang akan Berlaku jika Saya Membuat Pautan kepada Laman Web yang Lain?</b>
      	<br>
      	<br>
      	Laman web ini mempunyai pautan ke laman web lain. Dasar privasi ini hanya terpakai untuk laman web ini sahaja. Perlu diingatkan bahawa laman web yang terdapat dalam pautan mungkin mempunyai dasar privasi yang berbeza dan pengunjung dinasihatkan supaya meneliti dan memahami dasar privasi bagi setiap laman web yang dilayari.
      	<br>
      	<br>
      	<b style="font-size: 16px;">Pindaan Dasar</b>
      	<br>
      	<br>
      	Sekiranya dasar privasi ini dipinda, pindaan akan dikemas kini di halaman ini. Dengan sering melayari halaman ini, anda akan dikemas kini dengan maklumat yang dikumpul, cara ia digunakan dan dalam keadaan tertentu, bagaimana maklumat dikongsi bersama pihak yang lain.
      	<br>
      	<br>
      </w-card>
      
    </z-page>
  </zen-one>
</template>


<script>
// import { reactive } from 'vue'
// import ZResource from '@/Modules/z-resource'

export default {
  // extends: ZResource,
  components: {
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'privasi',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Premis', route: '/daftar/premis' },
        { label: 'Papar', route: '/daftar/premis/'+this.id },
      ],
      data : {id : 0},
    }
  },
  methods: {

  },
  watch: {

  },
  mounted() {
    
  },
}
</script>
